import { render, staticRenderFns } from "./LabsReports.vue?vue&type=template&id=b3c06588&"
import script from "./LabsReports.vue?vue&type=script&lang=js&"
export * from "./LabsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports